import { render, staticRenderFns } from "./DialogV1.vue?vue&type=template&id=652933a7&scoped=true"
import script from "./DialogV1.vue?vue&type=script&lang=js"
export * from "./DialogV1.vue?vue&type=script&lang=js"
import style0 from "./DialogV1.vue?vue&type=style&index=0&id=652933a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652933a7",
  null
  
)

export default component.exports